import { jsx as _jsx } from "react/jsx-runtime";
import { RichText as SitecoreRichText } from '@sitecore-content-sdk/nextjs';
export const Default = (props)=>{
    const text = props.fields ? /*#__PURE__*/ _jsx(SitecoreRichText, {
        field: props.fields.Text
    }) : /*#__PURE__*/ _jsx("span", {
        className: "is-empty-hint",
        children: "Rich text"
    });
    const id = props.params.RenderingIdentifier;
    const styleClass = props?.params?.styles?.trimEnd() ?? '';
    return /*#__PURE__*/ _jsx("div", {
        className: `component rich-text ${styleClass}`.trimEnd(),
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: text
        })
    });
};
